import { render, staticRenderFns } from "./AnexoCarlos.vue?vue&type=template&id=33017029&scoped=true&"
import script from "./AnexoCarlos.vue?vue&type=script&lang=js&"
export * from "./AnexoCarlos.vue?vue&type=script&lang=js&"
import style0 from "./AnexoCarlos.vue?vue&type=style&index=0&id=33017029&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33017029",
  null
  
)

export default component.exports